// extracted by mini-css-extract-plugin
export var blockBtn = "main-module--block-btn--f2238";
export var btnWrap = "main-module--btn-wrap--1c7e6";
export var mainBtn = "main-module--main-btn--81fd5";
export var mainTitle = "main-module--main-title--04ed5";
export var ofertaBtn = "main-module--oferta-btn--4bb50";